import { useEffect, useState } from "react";
export const FakeCounterSubscribed = ({ startNum = 1703, webId='' }) => {

  const webStorageName = typeof window !== "undefined" && localStorage[`peopleCounter-${webId}`];
  const webStorageNameStop = typeof window !== "undefined" && localStorage[`peopleCounterStop-${webId}`]

  let [start, setStart] = useState(typeof window !== "undefined" && webStorageName ? Number(webStorageName) : startNum);
  const stop = Number(webStorageNameStop) + 150;
  console.log(stop)

  useEffect(() => {
    const timer = setInterval(() => {

      if (start < stop) {
        setStart(start = start + 1);
        typeof window !== "undefined" && localStorage.setItem(`peopleCounter-${webId}`, JSON.stringify(start));
      } else {
        typeof window !== "undefined" && localStorage.setItem(`peopleCounterStop-${webId}`, JSON.stringify(start));
        console.log('interval cleared')
        clearTimeout(timer);
      }
    }, 3000)
  })

  return start;
};
